/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "ਬੀਤਿਆ ਕੱਲ੍ਹ",
        "0": "ਅੱਜ",
        "1": "ਭਲਕੇ",
        "future": {
          "one": "{0} ਦਿਨ ਵਿੱਚ",
          "other": "{0} ਦਿਨਾਂ ਵਿੱਚ"
        },
        "past": {
          "one": "{0} ਦਿਨ ਪਹਿਲਾਂ",
          "other": "{0} ਦਿਨ ਪਹਿਲਾਂ"
        }
      },
      "day-narrow": {
        "-1": "ਬੀਤਿਆ ਕੱਲ੍ਹ",
        "0": "ਅੱਜ",
        "1": "ਭਲਕੇ",
        "future": {
          "one": "{0} ਦਿਨ ਵਿੱਚ",
          "other": "{0} ਦਿਨਾਂ ਵਿੱਚ"
        },
        "past": {
          "one": "{0} ਦਿਨ ਪਹਿਲਾਂ",
          "other": "{0} ਦਿਨ ਪਹਿਲਾਂ"
        }
      },
      "day-short": {
        "-1": "ਬੀਤਿਆ ਕੱਲ੍ਹ",
        "0": "ਅੱਜ",
        "1": "ਭਲਕੇ",
        "future": {
          "one": "{0} ਦਿਨ ਵਿੱਚ",
          "other": "{0} ਦਿਨਾਂ ਵਿੱਚ"
        },
        "past": {
          "one": "{0} ਦਿਨ ਪਹਿਲਾਂ",
          "other": "{0} ਦਿਨ ਪਹਿਲਾਂ"
        }
      },
      "hour": {
        "0": "ਇਸ ਘੰਟੇ",
        "future": {
          "one": "{0} ਘੰਟੇ ਵਿੱਚ",
          "other": "{0} ਘੰਟਿਆਂ ਵਿੱਚ"
        },
        "past": {
          "one": "{0} ਘੰਟਾ ਪਹਿਲਾਂ",
          "other": "{0} ਘੰਟੇ ਪਹਿਲਾਂ"
        }
      },
      "hour-narrow": {
        "0": "ਇਸ ਘੰਟੇ",
        "future": {
          "one": "{0} ਘੰਟੇ ਵਿੱਚ",
          "other": "{0} ਘੰਟਿਆਂ ਵਿੱਚ"
        },
        "past": {
          "one": "{0} ਘੰਟਾ ਪਹਿਲਾਂ",
          "other": "{0} ਘੰਟੇ ਪਹਿਲਾਂ"
        }
      },
      "hour-short": {
        "0": "ਇਸ ਘੰਟੇ",
        "future": {
          "one": "{0} ਘੰਟੇ ਵਿੱਚ",
          "other": "{0} ਘੰਟਿਆਂ ਵਿੱਚ"
        },
        "past": {
          "one": "{0} ਘੰਟਾ ਪਹਿਲਾਂ",
          "other": "{0} ਘੰਟੇ ਪਹਿਲਾਂ"
        }
      },
      "minute": {
        "0": "ਇਸ ਮਿੰਟ",
        "future": {
          "one": "{0} ਮਿੰਟ ਵਿੱਚ",
          "other": "{0} ਮਿੰਟਾਂ ਵਿੱਚ"
        },
        "past": {
          "one": "{0} ਮਿੰਟ ਪਹਿਲਾਂ",
          "other": "{0} ਮਿੰਟ ਪਹਿਲਾਂ"
        }
      },
      "minute-narrow": {
        "0": "ਇਸ ਮਿੰਟ",
        "future": {
          "one": "{0} ਮਿੰਟ ਵਿੱਚ",
          "other": "{0} ਮਿੰਟਾਂ ਵਿੱਚ"
        },
        "past": {
          "one": "{0} ਮਿੰਟ ਪਹਿਲਾਂ",
          "other": "{0} ਮਿੰਟ ਪਹਿਲਾਂ"
        }
      },
      "minute-short": {
        "0": "ਇਸ ਮਿੰਟ",
        "future": {
          "one": "{0} ਮਿੰਟ ਵਿੱਚ",
          "other": "{0} ਮਿੰਟਾਂ ਵਿੱਚ"
        },
        "past": {
          "one": "{0} ਮਿੰਟ ਪਹਿਲਾਂ",
          "other": "{0} ਮਿੰਟ ਪਹਿਲਾਂ"
        }
      },
      "month": {
        "-1": "ਪਿਛਲਾ ਮਹੀਨਾ",
        "0": "ਇਹ ਮਹੀਨਾ",
        "1": "ਅਗਲਾ ਮਹੀਨਾ",
        "future": {
          "one": "{0} ਮਹੀਨੇ ਵਿੱਚ",
          "other": "{0} ਮਹੀਨਿਆਂ ਵਿੱਚ"
        },
        "past": {
          "one": "{0} ਮਹੀਨਾ ਪਹਿਲਾਂ",
          "other": "{0} ਮਹੀਨੇ ਪਹਿਲਾਂ"
        }
      },
      "month-narrow": {
        "-1": "ਪਿਛਲਾ ਮਹੀਨਾ",
        "0": "ਇਹ ਮਹੀਨਾ",
        "1": "ਅਗਲਾ ਮਹੀਨਾ",
        "future": {
          "one": "{0} ਮਹੀਨੇ ਵਿੱਚ",
          "other": "{0} ਮਹੀਨਿਆਂ ਵਿੱਚ"
        },
        "past": {
          "one": "{0} ਮਹੀਨਾ ਪਹਿਲਾਂ",
          "other": "{0} ਮਹੀਨੇ ਪਹਿਲਾਂ"
        }
      },
      "month-short": {
        "-1": "ਪਿਛਲਾ ਮਹੀਨਾ",
        "0": "ਇਹ ਮਹੀਨਾ",
        "1": "ਅਗਲਾ ਮਹੀਨਾ",
        "future": {
          "one": "{0} ਮਹੀਨੇ ਵਿੱਚ",
          "other": "{0} ਮਹੀਨਿਆਂ ਵਿੱਚ"
        },
        "past": {
          "one": "{0} ਮਹੀਨਾ ਪਹਿਲਾਂ",
          "other": "{0} ਮਹੀਨੇ ਪਹਿਲਾਂ"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "ਪਿਛਲੀ ਤਿਮਾਹੀ",
        "0": "ਇਸ ਤਿਮਾਹੀ",
        "1": "ਅਗਲੀ ਤਿਮਾਹੀ",
        "future": {
          "one": "{0} ਤਿਮਾਹੀ ਵਿੱਚ",
          "other": "{0} ਤਿਮਾਹੀਆਂ ਵਿੱਚ"
        },
        "past": {
          "one": "{0} ਤਿਮਾਹੀ ਪਹਿਲਾਂ",
          "other": "{0} ਤਿਮਾਹੀਆਂ ਪਹਿਲਾਂ"
        }
      },
      "quarter-narrow": {
        "-1": "ਪਿਛਲੀ ਤਿਮਾਹੀ",
        "0": "ਇਹ ਤਿਮਾਹੀ",
        "1": "ਅਗਲੀ ਤਿਮਾਹੀ",
        "future": {
          "one": "{0} ਤਿਮਾਹੀ ਵਿੱਚ",
          "other": "{0} ਤਿਮਾਹੀਆਂ ਵਿੱਚ"
        },
        "past": {
          "one": "{0} ਤਿਮਾਹੀ ਪਹਿਲਾਂ",
          "other": "{0} ਤਿਮਾਹੀਆਂ ਪਹਿਲਾਂ"
        }
      },
      "quarter-short": {
        "-1": "ਪਿਛਲੀ ਤਿਮਾਹੀ",
        "0": "ਇਹ ਤਿਮਾਹੀ",
        "1": "ਅਗਲੀ ਤਿਮਾਹੀ",
        "future": {
          "one": "{0} ਤਿਮਾਹੀ ਵਿੱਚ",
          "other": "{0} ਤਿਮਾਹੀਆਂ ਵਿੱਚ"
        },
        "past": {
          "one": "{0} ਤਿਮਾਹੀ ਪਹਿਲਾਂ",
          "other": "{0} ਤਿਮਾਹੀਆਂ ਪਹਿਲਾਂ"
        }
      },
      "second": {
        "0": "ਹੁਣ",
        "future": {
          "one": "{0} ਸਕਿੰਟ ਵਿੱਚ",
          "other": "{0} ਸਕਿੰਟਾਂ ਵਿੱਚ"
        },
        "past": {
          "one": "{0} ਸਕਿੰਟ ਪਹਿਲਾਂ",
          "other": "{0} ਸਕਿੰਟ ਪਹਿਲਾਂ"
        }
      },
      "second-narrow": {
        "0": "ਹੁਣ",
        "future": {
          "one": "{0} ਸਕਿੰਟ ਵਿੱਚ",
          "other": "{0} ਸਕਿੰਟਾਂ ਵਿੱਚ"
        },
        "past": {
          "one": "{0} ਸਕਿੰਟ ਪਹਿਲਾਂ",
          "other": "{0} ਸਕਿੰਟ ਪਹਿਲਾਂ"
        }
      },
      "second-short": {
        "0": "ਹੁਣ",
        "future": {
          "one": "{0} ਸਕਿੰਟ ਵਿੱਚ",
          "other": "{0} ਸਕਿੰਟਾਂ ਵਿੱਚ"
        },
        "past": {
          "one": "{0} ਸਕਿੰਟ ਪਹਿਲਾਂ",
          "other": "{0} ਸਕਿੰਟ ਪਹਿਲਾਂ"
        }
      },
      "week": {
        "-1": "ਪਿਛਲਾ ਹਫ਼ਤਾ",
        "0": "ਇਹ ਹਫ਼ਤਾ",
        "1": "ਅਗਲਾ ਹਫ਼ਤਾ",
        "future": {
          "one": "{0} ਹਫ਼ਤੇ ਵਿੱਚ",
          "other": "{0} ਹਫ਼ਤਿਆਂ ਵਿੱਚ"
        },
        "past": {
          "one": "{0} ਹਫ਼ਤਾ ਪਹਿਲਾਂ",
          "other": "{0} ਹਫ਼ਤੇ ਪਹਿਲਾਂ"
        }
      },
      "week-narrow": {
        "-1": "ਪਿਛਲਾ ਹਫ਼ਤਾ",
        "0": "ਇਹ ਹਫ਼ਤਾ",
        "1": "ਅਗਲਾ ਹਫ਼ਤਾ",
        "future": {
          "one": "{0} ਹਫ਼ਤੇ ਵਿੱਚ",
          "other": "{0} ਹਫ਼ਤਿਆਂ ਵਿੱਚ"
        },
        "past": {
          "one": "{0} ਹਫ਼ਤਾ ਪਹਿਲਾਂ",
          "other": "{0} ਹਫ਼ਤੇ ਪਹਿਲਾਂ"
        }
      },
      "week-short": {
        "-1": "ਪਿਛਲਾ ਹਫ਼ਤਾ",
        "0": "ਇਹ ਹਫ਼ਤਾ",
        "1": "ਅਗਲਾ ਹਫ਼ਤਾ",
        "future": {
          "one": "{0} ਹਫ਼ਤੇ ਵਿੱਚ",
          "other": "{0} ਹਫ਼ਤਿਆਂ ਵਿੱਚ"
        },
        "past": {
          "one": "{0} ਹਫ਼ਤਾ ਪਹਿਲਾਂ",
          "other": "{0} ਹਫ਼ਤੇ ਪਹਿਲਾਂ"
        }
      },
      "year": {
        "-1": "ਪਿਛਲਾ ਸਾਲ",
        "0": "ਇਹ ਸਾਲ",
        "1": "ਅਗਲਾ ਸਾਲ",
        "future": {
          "one": "{0} ਸਾਲ ਵਿੱਚ",
          "other": "{0} ਸਾਲਾਂ ਵਿੱਚ"
        },
        "past": {
          "one": "{0} ਸਾਲ ਪਹਿਲਾਂ",
          "other": "{0} ਸਾਲ ਪਹਿਲਾਂ"
        }
      },
      "year-narrow": {
        "-1": "ਪਿਛਲਾ ਸਾਲ",
        "0": "ਇਹ ਸਾਲ",
        "1": "ਅਗਲਾ ਸਾਲ",
        "future": {
          "one": "{0} ਸਾਲ ਵਿੱਚ",
          "other": "{0} ਸਾਲਾਂ ਵਿੱਚ"
        },
        "past": {
          "one": "{0} ਸਾਲ ਪਹਿਲਾਂ",
          "other": "{0} ਸਾਲ ਪਹਿਲਾਂ"
        }
      },
      "year-short": {
        "-1": "ਪਿਛਲਾ ਸਾਲ",
        "0": "ਇਹ ਸਾਲ",
        "1": "ਅਗਲਾ ਸਾਲ",
        "future": {
          "one": "{0} ਸਾਲ ਵਿੱਚ",
          "other": "{0} ਸਾਲਾਂ ਵਿੱਚ"
        },
        "past": {
          "one": "{0} ਸਾਲ ਪਹਿਲਾਂ",
          "other": "{0} ਸਾਲ ਪਹਿਲਾਂ"
        }
      }
    },
    "locale": "pa"
  });
}